<template>
	<div>
	<!-- ngIf: w.params.slotLimitInfo -->
	 <div ng-show="any" class="dialogWarning" ng-if="w.params.slotLimitInfo" keys="Error.ChampionSlotLimitReached:false,
												  Error.NoFreeChampionSlot:false,
												  Error.ChampionCitySlotLocked:true"><div class="warningHeader"><i class="symbol_warning_tiny_flat_white"></i><span translate=""><span>Предупреждение:</span></span></div><div class="warningContent single" ng-class="{single:warnings.length == 1}"><ul><!-- ngRepeat: w in warnings track by $index --><li ng-repeat="w in warnings track by $index" options="
												  Error.ChampionCitySlotLocked" data="" translate=""><span>Преобразуйте эту деревню в город, чтобы назначить второго чемпиона.</span></li><!-- end ngRepeat: w in warnings track by $index --></ul></div></div>
	<div class="championSlots contentBox gradient">
		<h6 class="contentBoxHeader headerTrapezoidal">
			<div class="content" translate=""><span>Места для чемпионов</span></div>
		</h6>
		<div class="contentBoxBody">
			<span translate="" data="slots:2"><span>Вы можете назначить до 2 чемпионов в игровом мире. Улучшите деревню до города, чтобы назначить 2 чемпионов на одну и ту же локацию.</span></span>
			<div class="filterBar">
				<!-- ngRepeat: n in [] | range:0:championSlots - 1 --><a class="filter iconButton active" ng-class="{active: usedSlots[n]}" ng-repeat="n in [] | range:0:championSlots - 1" tooltip="" tooltip-show="{&quot;champion&quot;:&quot;Верцингеторикс&quot;,&quot;village&quot;:&quot;New village&quot;}" tooltip-data="champion:Верцингеторикс, village:New village" tooltip-translate="MainBuilding.Champions.ChampionSlot.Tooltip.Assigned" content="Верцингеторикс через InZectorsk" v-tippy="{placement: 'bottom'}">
					<!-- ngIf: usedSlots[n] --><span ng-if="usedSlots[n]">1</span><!-- end ngIf: usedSlots[n] -->
					<!-- ngIf: !usedSlots[n] -->
				</a><!-- end ngRepeat: n in [] | range:0:championSlots - 1 --><a class="filter iconButton" ng-class="{active: usedSlots[n]}" ng-repeat="n in [] | range:0:championSlots - 1" tooltip="" tooltip-show="" tooltip-data="champion:, village:" tooltip-translate="MainBuilding.Champions.ChampionSlot.Tooltip.Assigned">
					<!-- ngIf: usedSlots[n] -->
					<!-- ngIf: !usedSlots[n] --><i ng-if="!usedSlots[n]" class="symbol_plus_tiny_flat_black"></i><!-- end ngIf: !usedSlots[n] -->
				</a><!-- end ngRepeat: n in [] | range:0:championSlots - 1 -->
				<!-- ngIf: !firstExtraChampionSlot --><button ng-if="!firstExtraChampionSlot" class="filter buyExtraSlot premium" premium-feature="championSlot" confirm-gold-usage="force" tooltip="" tooltip-translate="MainBuilding.Champions.ChampionSlot.Tooltip.ExtraChampionSlot" tooltip-data="slotPrice: 180" :content="tooltips[1]" v-tippy="{placement: 'bottom'}"><div class="content">
	<span ng-transclude="" class="innerText">
					<i class="symbol_plus_tiny_flat_black"></i>
				</span>
	<!-- ngIf: price > 0 || forceGoldUsage --><span class="price gold" ng-if="price &gt; 0 || forceGoldUsage"><i class="unit_gold_small_illu"></i>180</span><!-- end ngIf: price > 0 || forceGoldUsage -->
	<!-- ngIf: price == -1 && !forceGoldUsage -->

	<div class="animationOverlay"></div>
	<i class="checkmark action_check_small_flat_white"></i>
	<i class="checkmark action_check_small_flat_black"></i>
	<i class="checkmark action_check_small_flat_red"></i>
</div></button><!-- end ngIf: !firstExtraChampionSlot -->
			</div>
		</div>
	</div>

	<!-- ngRepeat: n in [] | range:1:2 --><div class="villageSlot contentBox gradient" ng-repeat="n in [] | range:1:2">
		<h6 class="contentBoxHeader headerTrapezoidal">
			<div class="content" options="1" translate=""><span>Слот деревни</span></div>
		</h6>
		<!-- ngIf: !champions[n] -->
		 <div ng-if="!champions[n]" class="contentBoxBody">
			<a class="iconButton clickable" ng-class="{disabled: usedSlots.length &gt;= championSlots || (n == 2 &amp;&amp; (!isTown || !champions[1])) || isWWVillage}" clickable="openOverlay('selectChampion')" tooltip="" tooltip-translate-switch="{
			    'Error.ChampionCitySlotLocked': false,
				'Error.ChampionSlotLimitReached': false
			}">
				<!-- ngIf: n != 2 || isTown --><i ng-if="n != 2 || isTown" class="symbol_plus_small_flat_black"></i><!-- end ngIf: n != 2 || isTown -->
				<!-- ngIf: n == 2 && !isTown -->
			</a>
			<!-- ngIf: (n == 1 || isTown) && !isWWVillage --><span ng-if="(n == 1 || isTown) &amp;&amp; !isWWVillage" options="1" translate=""><span>Назначить чемпиона в эту локацию. Бонусный эффект чемпиона станет активным после некоторого времени ожидания.</span></span><!-- end ngIf: (n == 1 || isTown) && !isWWVillage -->
			<!-- ngIf: (n == 2 && !isTown) && !isWWVillage -->
			<!-- ngIf: isWWVillage -->
		</div>
		<!-- ngIf: champions[n] --><div ng-if="champions[n]" class="contentBoxBody">
			<div class="championProfileImage vercingetorix rarity0 smallProfileImage"></div>
			<div class="details">
				<strong options="vercingetorix" translate=""><span>Верцингеторикс</span></strong><br>
				<span data="level: 0" translate=""><span>Уровень навыка: 0</span></span><br>
				<strong options="vercingetorix" data="bonus: 25" translate=""><span>&#x202D;+&#x202D;25&#x202C;%&#x202C; уклонение от войск</span></strong><br>
				 <strong ng-if="champions[n].deployTime > currentServerTime" data="time: 1753751857" translate=""><span>Эффект активен в:  </span><span countdown="1753751857" callback="">11:59:46</span></strong>
			</div>
			<div class="buttons">
				<button clickable="openOverlay('upgradeChampion', {'champion': 2})" @click="gameModel.buildings.house.upgradeChampionShow = true" ng-class="{disabled: champions[n].level &gt;= config.balancing.championConfig.upgrades.length}" class="clickable"><div class="content">
	<span ng-transclude="" class="innerText">
					<span translate=""><span>Улучшить</span></span>
				</span>
	<!-- ngIf: price > 0 || forceGoldUsage -->
	<!-- ngIf: price == -1 && !forceGoldUsage -->

	<div class="animationOverlay"></div>
	<i class="checkmark action_check_small_flat_white"></i>
	<i class="checkmark action_check_small_flat_black"></i>
	<i class="checkmark action_check_small_flat_red"></i>
</div></button>
				<button clickable="unassignChampion(1)" class="clickable"><div class="content">
	<span ng-transclude="" class="innerText">
					<span translate=""><span>Отменить назначение</span></span>
				</span>
	<!-- ngIf: price > 0 || forceGoldUsage -->
	<!-- ngIf: price == -1 && !forceGoldUsage -->

	<div class="animationOverlay"></div>
	<i class="checkmark action_check_small_flat_white"></i>
	<i class="checkmark action_check_small_flat_black"></i>
	<i class="checkmark action_check_small_flat_red"></i>
</div></button>
			</div>
		</div><!-- end ngIf: champions[n] -->
	</div><!-- end ngRepeat: n in [] | range:1:2 --><div class="villageSlot contentBox gradient" ng-repeat="n in [] | range:1:2">
		<h6 class="contentBoxHeader headerTrapezoidal">
			<div class="content" options="2" translate=""><span>Слот города</span></div>
		</h6>
		<!-- ngIf: !champions[n] --><div ng-if="!champions[n]" class="contentBoxBody">
			<a class="iconButton clickable disabled" ng-class="{disabled: usedSlots.length &gt;= championSlots || (n == 2 &amp;&amp; (!isTown || !champions[1])) || isWWVillage}" clickable="openOverlay('selectChampion')" tooltip="" tooltip-translate-switch="{
			    'Error.ChampionCitySlotLocked': true,
				'Error.ChampionSlotLimitReached': false
			}">
				<!-- ngIf: n != 2 || isTown -->
				<!-- ngIf: n == 2 && !isTown --><i ng-if="n == 2 &amp;&amp; !isTown" class="symbol_lock_medium_flat_black"></i><!-- end ngIf: n == 2 && !isTown -->
			</a>
			<!-- ngIf: (n == 1 || isTown) && !isWWVillage -->
			<!-- ngIf: (n == 2 && !isTown) && !isWWVillage --><span ng-if="(n == 2 &amp;&amp; !isTown) &amp;&amp; !isWWVillage" options="2" translate=""><span>Улучшите эту деревню до города, чтобы разблокировать второй слот чемпиона для этой локации.</span></span><!-- end ngIf: (n == 2 && !isTown) && !isWWVillage -->
			<!-- ngIf: isWWVillage -->
		</div><!-- end ngIf: !champions[n] -->
		<!-- ngIf: champions[n] -->
	</div><!-- end ngRepeat: n in [] | range:1:2 -->
	</div>
</template>

<style lang="scss">

</style>

<script>
import lib from '@/lib';

export default {
	mixins: lib.mixins,
	data: () => ({
		tooltips: {
			1: '<strong>Открыть дополнительный слот чемпиона</strong> <br><span>Открыть слот за  180 золота</span>',
		},
	}),
	computed: {},
	methods: {},
	components: {},
}
</script>
